import { useTranslate } from 'react-polyglot';

import { useHostClientContext } from '../../../HostClientProvider/hooks/useHostClientContext';
import { Players } from '../../../Players/Players';
import { useHostGameContext } from '../../HostGame.context';
import { Sidebar } from '../Sidebar/Sidebar';
import { StyledBigSubtitle, Wrapper } from './ParticipantsSidebar.styled';

interface ParticipantsSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ParticipantsSidebar = ({ isOpen, onClose }: ParticipantsSidebarProps) => {
  const t = useTranslate();
  const { client } = useHostClientContext();
  const { participantsSidebar } = useHostGameContext();

  const handleParticipantClick = () => {
    participantsSidebar.toggle();
  };

  return (
    <Sidebar isOpen={isOpen} onClose={onClose}>
      <Wrapper>
        <StyledBigSubtitle>
          {t('__new.play.creatorLobby.participants', { number: client.players.length })}
        </StyledBigSubtitle>

        <Players
          direction={Players.Direction.Column}
          playerWidthFull
          forcedPlayerSize={Players.PlayerSize.Small}
          onParticipantClick={handleParticipantClick}
        />
      </Wrapper>
    </Sidebar>
  );
};
